import { Button, Card, Col, message, Row, Typography } from "antd";
import CreateCollabOonboard from "assets/images/create-collab-success.png";
import { handleFacebookLogin } from "helpers/facebook-auth";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BusinessState } from "redux-context/business";
import { connectSocialMedia } from "services/SauceService";

const CollabSuccess: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { business } = useSelector((state: BusinessState) => state.business);

  const socialMediaConencted = useMemo(() => {
    return business?.socialMediasConnected?.some((socialMedia) =>
      ["instagram", "meta"].includes(
        socialMedia?.socialMediaName?.toLowerCase()
      )
    );
  }, [business]);

  const handleFacebookResponse = async (response: any) => {
    if (response.status === "connected") {
      const businessId = localStorage.getItem("businessId");
      const accessToken = response.authResponse.accessToken;
      setLoading(true);
      try {
        await connectSocialMedia({
          businessId,
          accessToken,
        });
        setLoading(false);
        message.success("Meta Business connected successfully");
        navigate("/collab-success", {
          replace: true,
        });
      } catch (error: any) {
        console.log(error);
        message.error(
          error?.response?.data?.message || "Error connecting Meta Business"
        );
        setLoading(false);
      }
    } else {
      console.log("User is not logged in with Facebook");
    }
  };

  const onClickSigninMeta = () => {
    handleFacebookLogin(handleFacebookResponse);
  };

  return (
    <div className="home-applications" style={{ textAlign: "center" }}>
      <h1 className="header-1">Great - we are procuring creators!</h1>
      <Row>
        <Col xs={24}>
          <Card
            style={{
              padding: 40,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img src={CreateCollabOonboard} alt="Collabs empty" />
            <Typography.Title
              level={4}
              className="header-2"
              style={{ marginTop: 0, marginBottom: 20 }}
            >
              Collab Successfully Created
            </Typography.Title>
            <Typography.Text
              style={{ display: "block" }}
              className="text-regular"
            >
              Influencer applications, arrival times, and scheduled visits will
              appear here as they come in.
            </Typography.Text>

            {!socialMediaConencted && (
              <>
                <Typography.Text
                  className="text-regular"
                  style={{ display: "block", marginTop: 20 }}
                >
                  Connect your Meta Business — we'll take care of the rest and
                  keep you in the loop.
                </Typography.Text>

                <Button
                  htmlType="button"
                  type="primary"
                  onClick={onClickSigninMeta}
                  disabled={loading}
                  loading={loading}
                  style={{ marginTop: 20 }}
                >
                  Connect Meta Business
                </Button>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CollabSuccess;
